import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.003 21.607c.32.733.497 1.543.497 2.393a5.97 5.97 0 0 1-.593 2.6l11.475 6.269a6 6 0 1 1-.749 1.87l-11.892-6.496A5.982 5.982 0 0 1 11.5 30c-3.312 0-6-2.69-6-6 0-3.312 2.69-6 6-6 1.74 0 3.308.743 4.405 1.928l11.782-6.436A6.004 6.004 0 0 1 33.5 6c3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6a5.997 5.997 0 0 1-4.994-2.676l-11.503 6.283Z",
    fill: "currentColor"
  }));
};

var SvgShare = styled(SvgComponent).withConfig({
  displayName: "Share__SvgShare",
  componentId: "sc-25jvuz-0"
})(["", " ", ""], size, color);
export default SvgShare;